$(document).ready( function(){

	SubnavToggle();

	if ($('.hamburglar').length > 0){
	    $('.hamburglar').click( function(){
	    	$(this).toggleClass('open');
	        $('.navigation-wrapper').toggleClass('open');
	        $('.page-wrap').toggleClass('hidden');
	    });
	}

	function SubnavToggle(){
		var wrapper = $('.navigation-wrapper');
		var has_children = wrapper.find('.menu-item.has-children');
		var trigger = has_children.children('.toggle');
	    trigger.click( function(e){
	    	e.preventDefault();
	    	$("this,.menu-item,.subnav").removeClass('open');
	    	$('.megamenu').removeClass('on');

	    	if($(this).hasClass('open')){
	    		$(this).removeClass('open');
	    	}else {
	    		$(this).addClass('open');
	    	}
	    	$(this).parent('.menu-item').toggleClass('open');
	    	$(this).parent('.menu-item').find('.subnav').toggleClass('open');
	    	$(this).parent('.menu-item').find('.megamenu').toggleClass('on');
	    });
	}

});